import { render, staticRenderFns } from "./common_wrapper.vue?vue&type=template&id=9358ab0e&scoped=true"
import script from "./common_wrapper.vue?vue&type=script&lang=js"
export * from "./common_wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9358ab0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\IdeaProjects\\wx\\shiliu-shop-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9358ab0e')) {
      api.createRecord('9358ab0e', component.options)
    } else {
      api.reload('9358ab0e', component.options)
    }
    module.hot.accept("./common_wrapper.vue?vue&type=template&id=9358ab0e&scoped=true", function () {
      api.rerender('9358ab0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/theme_editor/components/mobilePage/common_wrapper.vue"
export default component.exports